// queries/useGetStatistics.js
import { useQuery, useQueryClient } from "react-query";
import axiosInstance from "../config/Axios";

const fetchStatistics = async (id) => {
  const res = await axiosInstance.get(`/viewers/${id}/analytics`);
  return res.data;
};

export const useGetStatistics = (id, enabled = true) => {
  return useQuery(['getStatistics', id], () => fetchStatistics(id), {
    enabled: enabled && !!id,
    // normal background cadence (lightweight) — dialog will do a faster short burst
    refetchInterval: 60_000,
    staleTime: 5 * 60_000,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });
};
